import * as Api from '../apiCalls/employees/employeeApiCalls';
import { fetchBrary } from '../utils/FetchBrary';
import CrudActionService from '../utils/ReduxCrudBuilder/CrudActionService';
import { addNotificationToApp } from './NotificationsActions';

const EmployeeActionService = new CrudActionService("Employee", "Employees");
const EmployeeDependentActionService = new CrudActionService("EmployeeDependent", "EmployeeDependents");

const ROOT_URL = process.env.REACT_APP_API_URL;

export function fetchAddEmployeeDependent(dependent, employeeId, groupId) {
    return async (dispatch) => {
        dispatch(EmployeeDependentActionService.addEmployeeDependent());

        try {
            // ToDo: Warn: Test this in normal / non GTFF FLOW!!!
            const json = await Api.addEmployeeDependent(groupId, employeeId, dependent);
            dispatch(EmployeeDependentActionService.addEmployeeDependentSuccess(json));
            dispatch(addNotificationToApp("Successfully Added Employee Dependent", "success"));
        }
        catch (err) {
            dispatch(EmployeeDependentActionService.addEmployeeDependentFailure(err));
            dispatch(addNotificationToApp("Failed To Add Employee Dependent", "danger"));
        }
    };
}

export function fetchDeleteEmployeeDependent(dependentId, dependentDelete, employeeId, groupId) {
    return async (dispatch) => {
        dispatch(EmployeeDependentActionService.deleteEmployeeDependent());

        try {
            const json = await fetchBrary.deleteWithBody(`${ROOT_URL}/api/groups/${groupId}/employees/${employeeId}/dependents/${dependentId}`, dependentDelete);
            dispatch(EmployeeDependentActionService.deleteEmployeeDependentSuccess(json));
            dispatch(fetchEmployeeDependents(employeeId, groupId));
            dispatch(addNotificationToApp("Employee Dependent Deleted Successfully", "success"));
        }
        catch (err) {
            dispatch(EmployeeDependentActionService.deleteEmployeeDependentFailure(err));
            dispatch(addNotificationToApp("Failed To Delete Employee Dependent", "danger"));
        }
    };
}

export function fetchEmployee(personId, packageId) {
    return async (dispatch) => {
        dispatch(EmployeeActionService.requestEmployee(personId, packageId));

        try {
            const json = await Api.getEmployeePackagePersonData(packageId, personId);
            dispatch(EmployeeActionService.requestEmployeeSuccess(json));
            return json;
        }
        catch (err) {
            dispatch(EmployeeActionService.requestEmployeeFailure(err));
            dispatch(addNotificationToApp("Failed To Fetch Employee", "danger"));
        }
    };
}

export function fetchEmployeeDependent(dependentId, employeeId, groupId) {
    return async (dispatch) => {
        dispatch(EmployeeDependentActionService.requestEmployeeDependent(dependentId, employeeId, groupId));

        try {
            const json = await Api.getEmployeeDependent(groupId, employeeId, dependentId);
            dispatch(EmployeeDependentActionService.requestEmployeeDependentSuccess(json));
            return json;
        }
        catch (err) {
            dispatch(EmployeeDependentActionService.requestEmployeeDependentFailure(err));
            dispatch(addNotificationToApp("Failed To Fetch Employee Dependent", "danger"));
        }
    };
}

export function fetchEmployeeDependents(employeeId, groupId, packageId) {
    return async (dispatch) => {
        dispatch(EmployeeDependentActionService.requestEmployeeDependents(employeeId, groupId));

        try {
            const json = await fetchBrary.get(`${ROOT_URL}/api/packages/${packageId}/dependents/${employeeId}`);
            dispatch(EmployeeDependentActionService.requestEmployeeDependentsSuccess(json));
        }
        catch (err) {
            dispatch(EmployeeDependentActionService.requestEmployeeDependentsFailure(err));
            dispatch(addNotificationToApp("Failed To Fetch Employee Dependents", "danger"));
        }
    };
}

export function fetchUpdateEmployee(personId, packageId, employee) {
    return async (dispatch) => {
        dispatch(EmployeeActionService.updateEmployee());

        try {
            // ToDo: Warn: Test this in normal / non GTFF FLOW!!!
            const json = await Api.updateEmployee(packageId, personId, employee);
            dispatch(EmployeeActionService.updateEmployeeSuccess(json));
            dispatch(fetchEmployee(personId, packageId));
            dispatch(addNotificationToApp("Successfully Updated Employee", "success"));
        }
        catch (err) {
            dispatch(EmployeeActionService.updateEmployeeFailure(err));
            dispatch(addNotificationToApp("Failed To Update Employee", "danger"));
        }
    };
}

export function fetchUpdateEmployeeDependent(dependentId, dependent, employeeId, groupId) {
    return async (dispatch) => {
        dispatch(EmployeeDependentActionService.updateEmployeeDependent());

        try {
            const json = await Api.updateEmployeeDependent(groupId, employeeId, dependentId, dependent);
            dispatch(EmployeeDependentActionService.updateEmployeeDependentSuccess(json));
            dispatch(fetchEmployeeDependent(dependentId, employeeId, groupId));
            dispatch(addNotificationToApp("Employee Dependent Successfully Updated", "success"));
        }
        catch (err) {
            dispatch(EmployeeDependentActionService.updateEmployeeDependentFailure(err));
            dispatch(addNotificationToApp("Failed To Update Employee Dependent", "danger"));
        }
    };
}

